<!-- 符合性声明 明细 sqm -->
<template>
  <ComponentConformityDeclarations :kindType="data.kindType" :getData="data.getData" v-if="data.getData.supplyCode" @backBtn="routerBack"
    :subLoading="data.subLoading"></ComponentConformityDeclarations>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  import ComponentConformityDeclarations from "../ComponentConformityDeclarations"
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    kindType:'sqmDetail',
    getData:{},
    subLoading:false,
  })
  const routerBack = () => {
    proxy.$router.back()
  }
  const getInfo = () => {
    proxy.$http({
          url: "/base/rohs/getConformityDeclarationsDetailInfo?conformityDeclarationsId="+data.conformityDeclarationsId,
          method: "get",
        }).then(res=>{
          if(res.data.data){
            data.getData = res.data.data
          }
        }).catch(err=>{

        }).finally(()=>{
          data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
          data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''
        })
  }
  onBeforeMount(()=>{
    if (route.query) {
      data.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.userName = route.query.userName ?  route.query.userName : ''
      data.trueName = route.query.trueName ?  route.query.trueName : ''
      data.kindType = route.query.kindType ? route.query.kindType : 'sqmDetail'
      data.sourceId = route.query.sourceId ?  route.query.sourceId : undefined
      data.conformityDeclarationsId = route.query.conformityDeclarationsId ? route.query.conformityDeclarationsId : undefined
    }    
  })
  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          routerBack()
        },})
      return
    }
    getInfo()
    for(let i = 1 ; i < 10; i++){
      setTimeout(() => {
        proxy.postThisPageHeightMore()
      }, i*100);
    }
  })
</script>

<style>

</style>